import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { MenuButtonComponent } from "@components/menu-button/menu-button.component";
import { IArbetsorder } from "~app/features/planera/model/IArbetsorder";
import { ArbetsorderMasshanteringComponent } from "./masshantering/arbetsorder-masshantering.component";

@Component({
    selector: "rask-arbetsorder-bulk-context-menu",
    templateUrl: "./arbetsorder-bulk-context-menu.component.html",
    styleUrls: ["./arbetsorder-bulk-context-menu.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MenuButtonComponent,
        ArbetsorderMasshanteringComponent
    ]
})
export class ArbetsorderBulkContextMenuComponent {
    @Input() data: IArbetsorder[];
}
